module.exports = __webpack_public_path__ + "img/bg-xjsj.6917f74a.png";